export default __webpack_public_path__ + "static/media/WebsiteIcon.4eb95c90.svg";